import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const StopwatchIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.5 -9.53674e-07V1.84H9.5V-9.53674e-07H14.5ZM12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C13.96 3.18 15.78 3.84 17.26 4.94L18.68 3.52L20 4.84L18.64 6.2C19.98 7.76 20.82 9.78 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12 4.98C8.2 4.98 5.06 8.14 5.06 11.96C5.06 15.78 8.2 18.94 12 18.94C15.8 18.94 18.94 15.78 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98ZM11.08 13.34V7.14H12.92V13.34H11.08Z" />
    </SvgIcon>
  );
});
